import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface IDashboardStrings extends LocalizedStringsMethods {
    lsBreadCrumNavigatorTxt: string;
    lsGreetingMrngTxt: string;
    lsGreetingAftrnTxt: string;
    lsGreetingEveTxt: string;
    lsBaselineCntTxt: string;
    lsProfileTxt: string;
    lsImpairedProfileTxt: string;
    lsOverviewTxt: string;
    lsTotalProfileTxt: string;
    lsTotalBaselineTxt: string;
    lsTotalTestTxt: string;
    lsIOSUpdateTxt: string;
    lsIOSUpdateTxt2: string;
    lsIOSUpdateActionTxt: string;
    lsLearnMoreTxt: string;
    lsViewProfileLinkTxt: string;
    lsSettingsTxt: string;
    lsLogOutTxt: string;
    lsSharedTestTxt: string;
    lsSharedReturnToActivityTxt: string;
    lsSharedBy: string;
    lsOrgTxt: string;
    lsDateTxt: string;
    lsActionTxt: string;
    lsDownloadAllTxt: string;
    lsProfileNameTxt: string;
    lsDateRangeTxt: string;
    lsTestTxt: string;
    lsViewTxt: string;
    lsTotalTests: string;
    lsTotalSharees: string;
    lsTotalShares: string;
    lsShareesTxt: string;
    lsImpairedTxt: string;
}

let strings: IDashboardStrings;
export default strings = new LocalizedStrings({
    en: {
        lsBreadCrumNavigatorTxt: 'Home',
        lsGreetingMrngTxt: 'Good Morning',
        lsGreetingAftrnTxt: 'Good Afternoon',
        lsGreetingEveTxt: 'Good Evening',
        lsBaselineCntTxt: ' baselines were recorded in past 7 days',
        lsProfileTxt: ' profiles need a baseline',
        lsImpairedProfileTxt: ' profiles currently have impaired tests',
        lsOverviewTxt: 'Here\'s an overview of your account today',
        lsTotalProfileTxt: 'Total Profiles',
        lsTotalBaselineTxt: 'Total Baselines',
        lsTotalTestTxt: 'Total Tests',
        lsIOSUpdateTxt: 'The EyeGuide Focus app was recently updated.\
        The update should start installing automatically the next time you sync',
        lsIOSUpdateTxt2: 'Get the new version now.',
        lsIOSUpdateActionTxt: 'Action Needed: iOS Update Available',
        lsLearnMoreTxt: 'Learn More',
        lsViewProfileLinkTxt: 'View Profiles',
        lsSettingsTxt: 'Settings',
        lsLogOutTxt: 'Logout',
        lsSharedTestTxt: 'Shared Tests',
        lsSharedReturnToActivityTxt: 'Shared Return to Activity',
        lsSharedBy: 'Shared By',
        lsOrgTxt: 'Organization',
        lsDateTxt: 'Date',
        lsActionTxt: 'Action',
        lsDownloadAllTxt: 'Download All',
        lsProfileNameTxt: 'Profile Name',
        lsDateRangeTxt: 'Date Range',
        lsTestTxt: 'Tests',
        lsViewTxt: 'View',
        lsTotalTests: 'Total Tests',
        lsTotalSharees: 'Total Sharees',
        lsTotalShares: 'Total Shares',
        lsShareesTxt: 'Sharees',
        lsImpairedTxt: 'Poor'
    },
    es: {
        lsBreadCrumNavigatorTxt: 'Casa',
        lsGreetingMrngTxt: 'Buenos días',
        lsGreetingAftrnTxt: 'Buenas tardes',
        lsGreetingEveTxt: 'Buenas tardes',
        lsBaselineCntTxt: ' las líneas de base se registraron en los últimos 7 días',
        lsProfileTxt: ' los perfiles necesitan una línea de base',
        lsImpairedProfileTxt: ' perfiles actualmente tienen pruebas deterioradas',
        lsOverviewTxt: 'Aquí hay una descripción general de su cuenta hoy',
        lsTotalProfileTxt: 'Total de perfiles',
        lsTotalBaselineTxt: 'Líneas de base totales',
        lsTotalTestTxt: 'Pruebas totales',
        lsIOSUpdateTxt: 'La aplicación EyeGuide Focus fue actualizada recientemente.\
        La actualización debería comenzar a instalarse automáticamente la próxima vez que se sincronice',
        lsIOSUpdateTxt2: 'Obtenga la nueva versión ahora.',
        lsIOSUpdateActionTxt: 'Acción necesaria: actualización de iOS disponible',
        lsLearnMoreTxt: 'Aprende más',
        lsViewProfileLinkTxt: 'Ver perfiles',
        lsSettingsTxt: 'Configuraciones',
        lsLogOutTxt: 'Cerrar sesión',
        lsSharedTestTxt: 'Shared Tests',
        lsSharedReturnToActivityTxt: 'Shared Return to Activity',
        lsSharedBy: 'Shared By',
        lsOrgTxt: 'Organization',
        lsDateTxt: 'Date',
        lsActionTxt: 'Action',
        lsDownloadAllTxt: 'Download All',
        lsProfileNameTxt: 'Profile Name',
        lsDateRangeTxt: 'Date Range',
        lsTestTxt: 'Tests',
        lsViewTxt: 'View',
        lsTotalTests: 'Total Tests',
        lsTotalSharees: 'Total Sharees',
        lsTotalShares: 'Total Shares',
        lsShareesTxt: 'Sharees',
        lsImpairedTxt: 'Poor'
     }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/strings.dashboard.tsx